<template>
  <div>
    <main role="main" style="padding-top: 0px">
      <div class="container-fluid right_wrapper">
        <CampaignListHeader
          v-if="!selecteCampaignGropuId"
          :showFilters="true"
        ></CampaignListHeader>
        <BreadCrumbHeader
          v-else-if="!showLoader"
          @backCalled="backToCampaignGroup"
          :selectedName="selectedCAmpaignGroupName"
          tabCalled='Campaign Groups'
        />
          
        <div
          v-if="showLoader"
          class="spinner-border"
          style="margin: auto; display: block; margin-top: 60px"
        ></div>
        <div v-else>
          <CampaignListGrid class="table_wrap" :campaignList="campaignList"></CampaignListGrid>

          <CampaignListGridFooter
            v-if="campaignList.length != 0"
            @openCampaignModal="openCampaignModal"
            :modalShow="modalShow"
            class=""
          ></CampaignListGridFooter>
        </div>
        <CampaignActions  />
      </div>
    </main>
    <div
      v-if="spinnerOnAddModal"
      class="spinner-border"
      style="margin: auto; display: block; margin-top: 60px"
    ></div>
    <div v-else>
      <EditCampaignGroupModal
        v-if="modalShow"
        :campaignId="'null'"
      ></EditCampaignGroupModal>
    </div>
  </div>
</template>

<script>
import CampaignListHeader from "@/components/campaign-list/CampaignListHeader1";
import CampaignListGrid from "@/components/campaign-list/CampaignListGrid";
import CampaignListGridFooter from "@/components/campaign/CampaignListGridFooter";
import EditCampaignGroupModal from "@/components/campaign-group/EditCampaignGroupModal";
import CampaignActions from "@/components/campaign-list/CampaignActions";
import BreadCrumbHeader from "@/components/BreadCrumbHeader.vue";
export default {
  name: "CampaignList",
  data() {
    return {
      //    list:[],
      modalShow: false,
      spinnerOnAddModal: false,
      isShowAddToCampaigngroup: false,
    };
  },
  components: {
    CampaignListHeader,
    CampaignListGrid,
    CampaignListGridFooter,
    EditCampaignGroupModal,
    CampaignActions,
    BreadCrumbHeader,
  },
  watch: {
    sort() {
      this.getCampaignList();
    },
  },
  computed: {
    campaignList: {
      set(val) {
        this.$store.state.campaign.campaignList = val;
      },
      get() {
        this.$store.state.campaign.actionSelectionControl = false;
        return this.$store.state.campaign.campaignList;
      },
    },
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
        this.getCampaignList();
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
    selectedCAmpaignGroupName: {
      set(val) {
        this.$store.state.campaign.selectedCAmpaignGroupName = val;
      },
      get() {
        return this.$store.state.campaign.selectedCAmpaignGroupName;
      },
    },
    showLoader: {
      get() {
        return this.$store.getters["getShowLoader"];
      },
    },
    selecteCampaignGropuId: {
      get() {
        return this.$route.params.groupId ? this.$route.params.groupId : false;
      },
    },
    selectedCampaignList: {
      get() {
        return this.$store.state.campaign.campaignToAddToGroupList;
      },
      set(val) {
        this.$store.state.campaign.campaignToAddToGroupList = val;
      },
    },
    campaignSelectedList: {
      set(val) {
        this.$store.state.campaign.campaignSelectedList = val;
      },
      get() {
        return this.$store.state.campaign.campaignSelectedList;
      },
    },
  },
  mounted() {
    this.$store.dispatch("callAnalytics", {
      data: window.location.href,
      this: this,
      type: "campaignList",
    });

    if (this.$store.state.calledFromCancel) {
      this.$store.state.calledFromCancel = false;
    } else {
      if (this.$route.params.groupId == "all") {
        this.$store.state.selectedCampaignGroupFilter = "";
      } else {
        if (this.$route.params.groupId) {
          this.$store.state.selectedCampaignGroupFilter =
            this.$route.params.groupId;
        } else {
          //    this.$store.state.selectedCampaignGroupFilter = "";
        }
      }
      if (this.selecteCampaignGropuId) {
        var calledFromCampGrp =
          this.$route.name == "campaignListPerGroup" ? true : false;
        this.$store.dispatch("campaign/getCampaignList", {
          selecteCampaignGropuId: this.selecteCampaignGropuId,
          ignoreAmsProfileId: calledFromCampGrp,
        });
      } else {
        this.$store.dispatch("campaign/getCampaignList");
      }
      this.$store.dispatch("getAllBrandProfile");
    }
  },
  methods: {
    getCampaignList() {
      this.$store.dispatch("campaign/getCampaignList");
    },
    openCampaignModal() {
      const vm = this;
      this.modalShow = true;
      $(".go-popover").popover("hide");
      vm.$nextTick(() => {
        window.$("#editCampaign").modal({
          show: true,
        });
        window.$("#editCampaign").on("hide.bs.modal", function (e) {
          e.stopImmediatePropagation();
          vm.modalShow = false;
        });
      });
    },
    saveNewCampaignGroup(Item) {
      let vm = this;
      this.$store.commit("hideLoadingSpinner", null, {
        root: true,
      });
      this.spinnerOnAddModal = true;
      this.$store
        .dispatch("campaign/addAndUpdateCampaignGroup", Item)
        .then((res) => {
          vm.$store.commit("updateLatestCampaignGroup", res.id, {
            root: true,
          });
          vm.updateSelectCampaignGroupList();
        });
    },
    updateSelectCampaignGroupList() {
      let vm = this;
      this.$store
        .dispatch("campaign/getCampaignGroupFilterList", {
          doNotActivateSpinner: true,
        })
        .then((res) => {
          $(".go-popover").popover("show");
          // $('[".go-popover"]').popover();
          vm.spinnerOnAddModal = false;
        });
    },
    isShowAddToCampaignButton(data) {
      this.isShowAddToCampaigngroup = data;
    },
    // campaignToAddToGroupList(data){
    //
    //    this.list = data
    //    this.$children[1].checkedID = [];
    // },
    backToCampaignGroup() {
      this.$router.push({ path: "/campaignGroupList" });
    },
  },
};
</script>

<style lang="scss">
</style>
